<template>
  <!-- PC version -->
  <nav
    v-if="isDesktop"
    class="bg-primary-200 h-12 box-border rounded-b-[16px] py-2 relative"
  >
    <div class="w-[1140px] mx-auto">
      <ul class="flex gap-1">
        <li class="nav-item nav-item--flight">
          <a
            class="relative h-8 inline-flex rounded-[4px] items-center pl-2 pr-5 py-1 gap-1 font-bold text-[16px] leading-none"
            :class="pcNavItemClass('FLIGHT')"
            href="/"
          >
            <i class="fa-solid fa-plane-up text-[14px]"></i>
            <span>国内格安航空券</span>
          </a>
        </li>
        <li v-if="!isAgent" class="nav-item nav-item--hotel">
          <a
            class="relative h-8 inline-flex rounded-[4px] items-center pl-2 pr-5 py-1 gap-1 font-bold text-[16px] leading-none"
            :class="pcNavItemClass('HOTEL')"
            href="/hotel/"
          >
            <i class="fa-solid fa-square-h text-[14px]"></i>
            <span>ホテル・旅館</span>
          </a>
        </li>
        <li v-if="!isAgent" class="nav-item nav-item--dp">
          <a
            class="relative h-8 inline-flex rounded-[4px] items-center pl-2 pr-5 py-1 gap-1 font-bold text-[16px] leading-none"
            :class="pcNavItemClass('DYNAMIC_PACKAGE')"
            href="/dp/"
          >
            <span
              v-if="!isNative"
              class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full bg-pink-600 text-xs font-semibold whitespace-nowrap text-white px-4 py-1 rounded-full z-10"
              >セットでお得</span
            >
            <span
              class="flex items-center justify-center gap-[2px] shrink-0 w-7 h-7"
            >
              <svg
                class="w-[11.667px] h-[11.667px]"
                viewBox="0 0 11.6667 11.6667"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M4.375 2.14193C4.375 1.36719 5.03581 0 5.83333 0C6.65365 0 7.29167 1.36719 7.29167 2.14193V3.64583L11.3249 6.35742C11.5299 6.49414 11.6667 6.72201 11.6667 6.97266V8.2487C11.6667 8.49935 11.416 8.68164 11.1654 8.5905L7.29167 7.29167V9.11458L8.5905 10.1172C8.68164 10.1855 8.75 10.2767 8.75 10.3906V11.3477C8.75 11.5299 8.5905 11.6667 8.4082 11.6667C8.38542 11.6667 8.36263 11.6667 8.33984 11.6667L5.83333 10.9375L3.30404 11.6667C3.28125 11.6667 3.25846 11.6667 3.23568 11.6667C3.05339 11.6667 2.91667 11.5299 2.91667 11.3477V10.3906C2.91667 10.2767 2.96224 10.1855 3.05339 10.1172L4.375 9.11458V7.29167L0.478516 8.5905C0.227865 8.68164 0 8.49935 0 8.2487V6.97266C0 6.72201 0.113932 6.49414 0.31901 6.35742L4.375 3.64583V2.14193Z"
                />
              </svg>
              <svg
                class="w-[10.208px] h-[10.208px]"
                viewBox="0 0 10.2083 10.2083"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M8.75 0C9.54753 0 10.2083 0.660807 10.2083 1.45833V8.75C10.2083 9.57031 9.54753 10.2083 8.75 10.2083H1.45833C0.638021 10.2083 0 9.57031 0 8.75V1.45833C0 0.660807 0.638021 0 1.45833 0H8.75ZM7.65625 7.47396V2.73438C7.65625 2.43815 7.4056 2.1875 7.10938 2.1875C6.79036 2.1875 6.5625 2.43815 6.5625 2.73438V4.55729H3.64583V2.73438C3.64583 2.43815 3.39518 2.1875 3.09896 2.1875C2.77995 2.1875 2.55208 2.43815 2.55208 2.73438V7.47396C2.55208 7.79297 2.77995 8.02083 3.09896 8.02083C3.39518 8.02083 3.64583 7.79297 3.64583 7.47396V5.65104H6.5625V7.47396C6.5625 7.79297 6.79036 8.02083 7.10938 8.02083C7.4056 8.02083 7.65625 7.79297 7.65625 7.47396Z"
                />
              </svg>
            </span>
            <span>国内航空券＋ホテル</span>
          </a>
        </li>
        <li v-if="!isAgent" class="nav-item nav-item--overseas">
          <a
            class="relative h-8 inline-flex rounded-[4px] items-center pl-2 pr-5 py-1 gap-1 font-bold text-[16px] leading-none text-indigo-900 hover:bg-primary-600 hover:text-white"
            href="/international-air/"
          >
            <span class="overflow-hidden relative shrink-0 w-7 h-7">
              <span
                class="absolute"
                style="top:27.08%;right:16.14%;bottom:27.08%;left:16.14%"
              >
                <svg
                  class="w-full h-full"
                  viewBox="0 0 18.9601 12.8333"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="currentColor"
                    d="M7.1296 10.3379V8.04477L8.90378 8.55248C8.90378 8.5212 8.89817 8.48992 8.89817 8.45864C8.89816 7.95927 8.96067 7.46186 9.08425 6.97802C9.11721 6.85078 9.16598 6.72818 9.22942 6.61307C9.24615 6.48339 9.27958 6.35641 9.32888 6.2353C9.36096 6.15509 9.40267 6.0821 9.43796 6.0051L7.1296 4.6857V2.08538C7.1296 1.32422 6.50639 0 5.70352 0C4.92391 0 4.27744 1.32582 4.27744 2.08538V4.6857L0.359328 6.92428C0.250043 6.98671 0.159232 7.07696 0.0961205 7.18586C0.0330089 7.29476 -0.000154189 7.41842 5.38961e-07 7.54428V8.79631C-5.69616e-06 8.85154 0.0128055 8.90602 0.037426 8.95546C0.0620464 9.0049 0.0978043 9.04795 0.141886 9.08122C0.185967 9.1145 0.237169 9.13709 0.291463 9.14722C0.345757 9.15735 0.40166 9.15474 0.454774 9.1396L4.27744 8.04477V10.3379L2.99413 11.3004C2.94988 11.3333 2.91393 11.3762 2.88915 11.4254C2.86436 11.4747 2.85142 11.5291 2.85136 11.5843V12.5203C2.85125 12.5614 2.85925 12.602 2.87488 12.64C2.89051 12.6779 2.91348 12.7124 2.94246 12.7415C2.97144 12.7705 3.00587 12.7936 3.04378 12.8093C3.08169 12.825 3.12232 12.8331 3.16336 12.8331C3.19267 12.8333 3.22185 12.8293 3.24999 12.8211L5.70352 12.1209L8.15705 12.8211C8.17873 12.8276 8.20106 12.8316 8.22363 12.8331C8.26603 12.8346 8.3083 12.8277 8.34801 12.8128C8.38771 12.7978 8.42406 12.7751 8.45494 12.746C8.48582 12.7169 8.51063 12.682 8.52792 12.6433C8.54521 12.6045 8.55465 12.5627 8.55568 12.5203V11.5851C8.55562 11.5299 8.54268 11.4755 8.5179 11.4263C8.49311 11.377 8.45716 11.3341 8.41291 11.3012L7.1296 10.3379Z"
                  />
                  <path
                    fill="currentColor"
                    d="M12.4769 7.38029C12.4341 7.74186 12.4106 8.10544 12.4063 8.4695C12.4111 8.83381 12.4346 9.19764 12.4769 9.55952H10.3779C10.1941 8.84447 10.1941 8.09454 10.3779 7.37949L12.4769 7.38029ZM10.5575 6.83569C10.8118 6.2078 11.2087 5.6477 11.7168 5.19972C12.2249 4.75174 12.8303 4.42817 13.4851 4.25462C12.9763 5.03076 12.6543 5.91421 12.5443 6.83569H10.5575ZM13.4851 12.6828C12.8304 12.5091 12.2251 12.1854 11.717 11.7375C11.2089 11.2895 10.8119 10.7295 10.5575 10.1017H12.5443C12.6543 11.0232 12.9763 11.9066 13.4851 12.6828ZM16.2346 8.4671C16.2342 8.83115 16.2155 9.19495 16.1785 9.55711H13.0207C12.9784 9.19522 12.9546 8.83141 12.9493 8.4671C12.9546 8.10305 12.9784 7.7395 13.0207 7.37789H16.1785C16.2155 7.73978 16.2342 8.10331 16.2346 8.4671ZM16.1039 6.83569H13.0961C13.1823 6.28133 13.3369 5.7398 13.5565 5.22352C13.6896 4.89645 13.8827 4.5972 14.126 4.34125C14.1816 4.26856 14.2532 4.20967 14.3353 4.16914C14.4174 4.12861 14.5077 4.10753 14.5992 4.10753C14.6907 4.10753 14.781 4.12861 14.8631 4.16914C14.9451 4.20967 15.0168 4.26856 15.0724 4.34125C15.3166 4.59663 15.5101 4.89601 15.6427 5.22352C15.8621 5.73991 16.017 6.28139 16.1039 6.83569ZM13.5565 11.7163C13.3371 11.2002 13.1824 10.659 13.0961 10.1049H16.1039C16.0169 10.6589 15.862 11.2001 15.6427 11.7163C15.5106 12.0441 15.317 12.3435 15.0724 12.5986C15.017 12.6715 14.9454 12.7307 14.8633 12.7714C14.7812 12.8121 14.6908 12.8333 14.5992 12.8333C14.5075 12.8333 14.4171 12.8121 14.3351 12.7714C14.253 12.7307 14.1814 12.6715 14.126 12.5986C13.8823 12.3429 13.6891 12.0436 13.5565 11.7163ZM18.6432 6.83569H16.6557C16.5456 5.91421 16.2236 5.03076 15.7149 4.25462C16.3697 4.42829 16.9752 4.75189 17.4834 5.19985C17.9916 5.64781 18.3887 6.20784 18.6432 6.83569ZM15.7141 12.6828C16.2228 11.9066 16.5448 11.0232 16.6549 10.1017H18.6424C18.3877 10.7295 17.9906 11.2894 17.4824 11.7373C16.9742 12.1853 16.3688 12.5089 15.7141 12.6828ZM18.8213 7.38029C19.0064 8.09518 19.0064 8.84543 18.8213 9.56032H16.7279C16.7643 9.19812 16.7825 8.83433 16.7824 8.47031C16.7829 8.10627 16.7647 7.74246 16.7279 7.38029H18.8213Z"
                  />
                </svg>
              </span>
            </span>
            <span>海外格安航空券</span>
          </a>
        </li>
        <li v-if="!isAgent">
          <a
            class="relative h-8 inline-flex rounded-[4px] items-center pl-2 pr-5 py-1 gap-1 font-bold text-[16px] leading-none text-indigo-900 hover:bg-primary-600 hover:text-white"
            href="/train/"
          >
            <span
              class="flex items-center justify-center gap-[2px] shrink-0 w-7 h-7"
            >
              <svg
                class="w-[9.188px] h-[10.5px]"
                viewBox="0 0 9.1875 10.5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M7.21875 0C8.30567 0 9.1875 0.881836 9.1875 1.96875V7.21875C9.1875 8.20313 8.44922 9.02344 7.50586 9.16699L8.44922 10.1104C8.59277 10.2539 8.49024 10.5 8.28516 10.5H7.48535C7.30078 10.5 7.13672 10.4385 7.01367 10.3154L5.90625 9.1875H3.28125L2.15332 10.3154C2.03027 10.4385 1.86621 10.5 1.68164 10.5H0.881836C0.676758 10.5 0.574219 10.2539 0.717774 10.1104L1.66113 9.16699C0.717774 9.02344 0 8.20313 0 7.21875V1.96875C0 0.881836 0.861328 0 1.96875 0H7.21875ZM1.3125 3.9375C1.3125 4.30664 1.59961 4.59375 1.96875 4.59375H7.21875C7.56738 4.59375 7.875 4.30664 7.875 3.9375V1.96875C7.875 1.62012 7.56738 1.3125 7.21875 1.3125H1.96875C1.59961 1.3125 1.3125 1.62012 1.3125 1.96875V3.9375ZM4.59375 7.875C5.12695 7.875 5.57813 7.44434 5.57813 6.89063C5.57813 6.35742 5.12695 5.90625 4.59375 5.90625C4.04004 5.90625 3.60938 6.35742 3.60938 6.89063C3.60938 7.44434 4.04004 7.875 4.59375 7.875Z"
                />
              </svg>
              <svg
                class="w-[10.208px] h-[10.208px]"
                viewBox="0 0 10.2083 10.2083"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M8.75 0C9.54753 0 10.2083 0.660807 10.2083 1.45833V8.75C10.2083 9.57031 9.54753 10.2083 8.75 10.2083H1.45833C0.638021 10.2083 0 9.57031 0 8.75V1.45833C0 0.660807 0.638021 0 1.45833 0H8.75ZM7.65625 7.47396V2.73438C7.65625 2.43815 7.4056 2.1875 7.10938 2.1875C6.79036 2.1875 6.5625 2.43815 6.5625 2.73438V4.55729H3.64583V2.73438C3.64583 2.43815 3.39518 2.1875 3.09896 2.1875C2.77995 2.1875 2.55208 2.43815 2.55208 2.73438V7.47396C2.55208 7.79297 2.77995 8.02083 3.09896 8.02083C3.39518 8.02083 3.64583 7.79297 3.64583 7.47396V5.65104H6.5625V7.47396C6.5625 7.79297 6.79036 8.02083 7.10938 8.02083C7.4056 8.02083 7.65625 7.79297 7.65625 7.47396Z"
                />
              </svg>
            </span>
            <span>JR+宿泊</span>
          </a>
        </li>
      </ul>
    </div>
  </nav>

  <!-- SP version -->
  <ul v-else class="bg-primary-200 flex w-full list-none py-1">
    <li class="flex-1 flex">
      <a
        class="flex-1 flex flex-col items-center text-center rounded-[4px] pt-1 pb-3 px-2 h-[49px] justify-center text-[12px] gap-0"
        :class="
          activeTab === 'FLIGHT'
            ? 'bg-primary-600 text-white font-bold'
            : 'bg-primary-200 text-indigo-900 font-normal'
        "
        href="/"
      >
        <i class="fa-solid fa-plane-up text-[12px]"></i>
        <p class="leading-[1.33]">国内航空券</p>
      </a>
    </li>
    <li v-if="!isAgent" class="flex-1 flex">
      <a
        class="flex-1 flex flex-col items-center text-center rounded-[4px] pt-1 pb-3 px-2 h-[49px] justify-center text-[12px] gap-0"
        :class="
          activeTab === 'HOTEL'
            ? 'bg-primary-600 text-white font-bold'
            : 'bg-primary-200 text-indigo-900 font-normal'
        "
        href="/hotel/"
      >
        <i class="fa-solid fa-square-h text-[12px]"></i>
        <p class="leading-[1.33]">ホテル</p>
      </a>
    </li>
    <li v-if="!isAgent" class="flex-1 flex">
      <a
        class="relative flex-1 flex flex-col items-center text-center rounded-[4px] pt-1 pb-3 px-2 h-[49px] justify-center text-[12px] gap-0"
        :class="
          activeTab === 'DYNAMIC_PACKAGE'
            ? 'bg-primary-600 text-white font-bold'
            : 'bg-primary-200 text-indigo-900 font-normal'
        "
        href="/dp/"
      >
        <span
          v-if="!isNative"
          class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full bg-pink-600 text-[10px] font-semibold leading-5 whitespace-nowrap text-white px-2 rounded-full"
          >セットでお得</span
        >
        <span class="flex gap-[2px] items-center justify-center w-6 h-6">
          <svg
            class="w-[10px] h-[10px]"
            viewBox="0 0 11.6667 11.6667"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M4.375 2.14193C4.375 1.36719 5.03581 0 5.83333 0C6.65365 0 7.29167 1.36719 7.29167 2.14193V3.64583L11.3249 6.35742C11.5299 6.49414 11.6667 6.72201 11.6667 6.97266V8.2487C11.6667 8.49935 11.416 8.68164 11.1654 8.5905L7.29167 7.29167V9.11458L8.5905 10.1172C8.68164 10.1855 8.75 10.2767 8.75 10.3906V11.3477C8.75 11.5299 8.5905 11.6667 8.4082 11.6667C8.38542 11.6667 8.36263 11.6667 8.33984 11.6667L5.83333 10.9375L3.30404 11.6667C3.28125 11.6667 3.25846 11.6667 3.23568 11.6667C3.05339 11.6667 2.91667 11.5299 2.91667 11.3477V10.3906C2.91667 10.2767 2.96224 10.1855 3.05339 10.1172L4.375 9.11458V7.29167L0.478516 8.5905C0.227865 8.68164 0 8.49935 0 8.2487V6.97266C0 6.72201 0.113932 6.49414 0.31901 6.35742L4.375 3.64583V2.14193Z"
            />
          </svg>
          <svg
            class="w-[8.75px] h-[8.75px]"
            viewBox="0 0 10.2083 10.2083"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M8.75 0C9.54753 0 10.2083 0.660807 10.2083 1.45833V8.75C10.2083 9.57031 9.54753 10.2083 8.75 10.2083H1.45833C0.638021 10.2083 0 9.57031 0 8.75V1.45833C0 0.660807 0.638021 0 1.45833 0H8.75ZM7.65625 7.47396V2.73438C7.65625 2.43815 7.4056 2.1875 7.10938 2.1875C6.79036 2.1875 6.5625 2.43815 6.5625 2.73438V4.55729H3.64583V2.73438C3.64583 2.43815 3.39518 2.1875 3.09896 2.1875C2.77995 2.1875 2.55208 2.43815 2.55208 2.73438V7.47396C2.55208 7.79297 2.77995 8.02083 3.09896 8.02083C3.39518 8.02083 3.64583 7.79297 3.64583 7.47396V5.65104H6.5625V7.47396C6.5625 7.79297 6.79036 8.02083 7.10938 8.02083C7.4056 8.02083 7.65625 7.79297 7.65625 7.47396Z"
            />
          </svg>
        </span>
        <p class="leading-[1.33]">航空券＋ホテル</p>
      </a>
    </li>
    <li v-if="!isAgent" class="flex-1 flex">
      <a
        class="relative flex-1 flex flex-col items-center text-center rounded-[4px] pt-1 pb-3 px-2 h-[49px] justify-center text-[12px] font-normal gap-0 bg-primary-200 text-indigo-900"
        href="/international-air/"
      >
        <span class="overflow-hidden relative w-6 h-6">
          <span
            class="absolute"
            style="top:27.08%;right:16.14%;bottom:27.08%;left:16.14%"
          >
            <svg
              class="w-full h-full"
              viewBox="0 0 18.9601 12.8333"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M7.1296 10.3379V8.04477L8.90378 8.55248C8.90378 8.5212 8.89817 8.48992 8.89817 8.45864C8.89816 7.95927 8.96067 7.46186 9.08425 6.97802C9.11721 6.85078 9.16598 6.72818 9.22942 6.61307C9.24615 6.48339 9.27958 6.35641 9.32888 6.2353C9.36096 6.15509 9.40267 6.0821 9.43796 6.0051L7.1296 4.6857V2.08538C7.1296 1.32422 6.50639 0 5.70352 0C4.92391 0 4.27744 1.32582 4.27744 2.08538V4.6857L0.359328 6.92428C0.250043 6.98671 0.159232 7.07696 0.0961205 7.18586C0.0330089 7.29476 -0.000154189 7.41842 5.38961e-07 7.54428V8.79631C-5.69616e-06 8.85154 0.0128055 8.90602 0.037426 8.95546C0.0620464 9.0049 0.0978043 9.04795 0.141886 9.08122C0.185967 9.1145 0.237169 9.13709 0.291463 9.14722C0.345757 9.15735 0.40166 9.15474 0.454774 9.1396L4.27744 8.04477V10.3379L2.99413 11.3004C2.94988 11.3333 2.91393 11.3762 2.88915 11.4254C2.86436 11.4747 2.85142 11.5291 2.85136 11.5843V12.5203C2.85125 12.5614 2.85925 12.602 2.87488 12.64C2.89051 12.6779 2.91348 12.7124 2.94246 12.7415C2.97144 12.7705 3.00587 12.7936 3.04378 12.8093C3.08169 12.825 3.12232 12.8331 3.16336 12.8331C3.19267 12.8333 3.22185 12.8293 3.24999 12.8211L5.70352 12.1209L8.15705 12.8211C8.17873 12.8276 8.20106 12.8316 8.22363 12.8331C8.26603 12.8346 8.3083 12.8277 8.34801 12.8128C8.38771 12.7978 8.42406 12.7751 8.45494 12.746C8.48582 12.7169 8.51063 12.682 8.52792 12.6433C8.54521 12.6045 8.55465 12.5627 8.55568 12.5203V11.5851C8.55562 11.5299 8.54268 11.4755 8.5179 11.4263C8.49311 11.377 8.45716 11.3341 8.41291 11.3012L7.1296 10.3379Z"
              />
              <path
                fill="currentColor"
                d="M12.4769 7.38029C12.4341 7.74186 12.4106 8.10544 12.4063 8.4695C12.4111 8.83381 12.4346 9.19764 12.4769 9.55952H10.3779C10.1941 8.84447 10.1941 8.09454 10.3779 7.37949L12.4769 7.38029ZM10.5575 6.83569C10.8118 6.2078 11.2087 5.6477 11.7168 5.19972C12.2249 4.75174 12.8303 4.42817 13.4851 4.25462C12.9763 5.03076 12.6543 5.91421 12.5443 6.83569H10.5575ZM13.4851 12.6828C12.8304 12.5091 12.2251 12.1854 11.717 11.7375C11.2089 11.2895 10.8119 10.7295 10.5575 10.1017H12.5443C12.6543 11.0232 12.9763 11.9066 13.4851 12.6828ZM16.2346 8.4671C16.2342 8.83115 16.2155 9.19495 16.1785 9.55711H13.0207C12.9784 9.19522 12.9546 8.83141 12.9493 8.4671C12.9546 8.10305 12.9784 7.7395 13.0207 7.37789H16.1785C16.2155 7.73978 16.2342 8.10331 16.2346 8.4671ZM16.1039 6.83569H13.0961C13.1823 6.28133 13.3369 5.7398 13.5565 5.22352C13.6896 4.89645 13.8827 4.5972 14.126 4.34125C14.1816 4.26856 14.2532 4.20967 14.3353 4.16914C14.4174 4.12861 14.5077 4.10753 14.5992 4.10753C14.6907 4.10753 14.781 4.12861 14.8631 4.16914C14.9451 4.20967 15.0168 4.26856 15.0724 4.34125C15.3166 4.59663 15.5101 4.89601 15.6427 5.22352C15.8621 5.73991 16.017 6.28139 16.1039 6.83569ZM13.5565 11.7163C13.3371 11.2002 13.1824 10.659 13.0961 10.1049H16.1039C16.0169 10.6589 15.862 11.2001 15.6427 11.7163C15.5106 12.0441 15.317 12.3435 15.0724 12.5986C15.017 12.6715 14.9454 12.7307 14.8633 12.7714C14.7812 12.8121 14.6908 12.8333 14.5992 12.8333C14.5075 12.8333 14.4171 12.8121 14.3351 12.7714C14.253 12.7307 14.1814 12.6715 14.126 12.5986C13.8823 12.3429 13.6891 12.0436 13.5565 11.7163ZM18.6432 6.83569H16.6557C16.5456 5.91421 16.2236 5.03076 15.7149 4.25462C16.3697 4.42829 16.9752 4.75189 17.4834 5.19985C17.9916 5.64781 18.3887 6.20784 18.6432 6.83569ZM15.7141 12.6828C16.2228 11.9066 16.5448 11.0232 16.6549 10.1017H18.6424C18.3877 10.7295 17.9906 11.2894 17.4824 11.7373C16.9742 12.1853 16.3688 12.5089 15.7141 12.6828ZM18.8213 7.38029C19.0064 8.09518 19.0064 8.84543 18.8213 9.56032H16.7279C16.7643 9.19812 16.7825 8.83433 16.7824 8.47031C16.7829 8.10627 16.7647 7.74246 16.7279 7.38029H18.8213Z"
              />
            </svg>
          </span>
        </span>
        <p class="leading-[1.33]">海外航空券</p>
      </a>
    </li>
    <li v-if="!isAgent" class="flex-1 flex">
      <a
        class="flex-1 flex flex-col items-center text-center rounded-[4px] pt-1 pb-3 px-2 h-[49px] justify-center text-[12px] font-normal gap-0 bg-primary-200 text-indigo-900"
        href="/train/"
      >
        <span class="flex gap-[2px] items-center justify-center w-6 h-6">
          <svg
            class="w-[7.875px] h-[9px]"
            viewBox="0 0 9.1875 10.5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M7.21875 0C8.30567 0 9.1875 0.881836 9.1875 1.96875V7.21875C9.1875 8.20313 8.44922 9.02344 7.50586 9.16699L8.44922 10.1104C8.59277 10.2539 8.49024 10.5 8.28516 10.5H7.48535C7.30078 10.5 7.13672 10.4385 7.01367 10.3154L5.90625 9.1875H3.28125L2.15332 10.3154C2.03027 10.4385 1.86621 10.5 1.68164 10.5H0.881836C0.676758 10.5 0.574219 10.2539 0.717774 10.1104L1.66113 9.16699C0.717774 9.02344 0 8.20313 0 7.21875V1.96875C0 0.881836 0.861328 0 1.96875 0H7.21875ZM1.3125 3.9375C1.3125 4.30664 1.59961 4.59375 1.96875 4.59375H7.21875C7.56738 4.59375 7.875 4.30664 7.875 3.9375V1.96875C7.875 1.62012 7.56738 1.3125 7.21875 1.3125H1.96875C1.59961 1.3125 1.3125 1.62012 1.3125 1.96875V3.9375ZM4.59375 7.875C5.12695 7.875 5.57813 7.44434 5.57813 6.89063C5.57813 6.35742 5.12695 5.90625 4.59375 5.90625C4.04004 5.90625 3.60938 6.35742 3.60938 6.89063C3.60938 7.44434 4.04004 7.875 4.59375 7.875Z"
            />
          </svg>
          <svg
            class="w-[8.75px] h-[8.75px]"
            viewBox="0 0 10.2083 10.2083"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M8.75 0C9.54753 0 10.2083 0.660807 10.2083 1.45833V8.75C10.2083 9.57031 9.54753 10.2083 8.75 10.2083H1.45833C0.638021 10.2083 0 9.57031 0 8.75V1.45833C0 0.660807 0.638021 0 1.45833 0H8.75ZM7.65625 7.47396V2.73438C7.65625 2.43815 7.4056 2.1875 7.10938 2.1875C6.79036 2.1875 6.5625 2.43815 6.5625 2.73438V4.55729H3.64583V2.73438C3.64583 2.43815 3.39518 2.1875 3.09896 2.1875C2.77995 2.1875 2.55208 2.43815 2.55208 2.73438V7.47396C2.55208 7.79297 2.77995 8.02083 3.09896 8.02083C3.39518 8.02083 3.64583 7.79297 3.64583 7.47396V5.65104H6.5625V7.47396C6.5625 7.79297 6.79036 8.02083 7.10938 8.02083C7.4056 8.02083 7.65625 7.79297 7.65625 7.47396Z"
            />
          </svg>
        </span>
        <p class="leading-[1.33]">JR+宿泊</p>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'GrobalNav',
  computed: {
    ...mapState({
      isDynamicPackage: 'isDynamicPackage',
      isNative: 'isNative',
    }),
    ...mapGetters(['hasHotel', 'hasFlights', 'hasBothFlightsAndHotel']),
    ...mapGetters('member', ['isAgent']),
    activeTab() {
      if (this.isDynamicPackage || this.hasBothFlightsAndHotel) {
        return 'DYNAMIC_PACKAGE';
      } else if (this.hasHotel) {
        return 'HOTEL';
      } else {
        return 'FLIGHT';
      }
    },
  },
  methods: {
    pcNavItemClass(tab) {
      return this.activeTab === tab
        ? 'bg-primary-600 rounded-[4px] text-white'
        : 'text-indigo-900 hover:bg-primary-600 hover:rounded-[4px] hover:text-white';
    },
  },
};
</script>
